module.exports = __webpack_public_path__ + "static/cover-large-2-d9e2f170e8ffab4d430c84c0336fb91c.jpg";